import Utils from "../utils/Utils";

const AdminComplaintController = {

  // GET - List complaints
  list: ({
    jwt,
    Authorization,
    page = 0,
    size = 20,
    search,
    status,
    fromDate,
    toDate,
    sort = "createdAt,desc",
  } = {}) => {
    const params = new URLSearchParams();

    params.append("page", page);
    params.append("size", size);
    params.append("sort", sort);

    if (search) params.append("search", search);
    if (status) params.append("status", status);
    if (fromDate) params.append("fromDate", fromDate);
    if (toDate) params.append("toDate", toDate);

    return Utils.controller(
      `api/admin/complaints/v1?${params.toString()}`,
      "",
      "GET",
      "",
      true,
      jwt || Authorization,
      true,
    );
  },

  // GET - Complaint details
  details: ({
    complaintId,
    jwt,
    Authorization,
  } = {}) => {
    return Utils.controller(
      `api/admin/complaints/v1/${complaintId}`,
      "",
      "GET",
      "",
      true,
      jwt || Authorization,
      true,
    );
  },

  // POST - Approve complaint
  approve: ({
    complaintId,
    jwt,
    Authorization,
  } = {}) => {
    return Utils.controller(
      `api/admin/complaints/v1/${complaintId}/approve`,
      "",
      "POST",
      "",
      true,
      jwt || Authorization,
      true,
    );
  },

  // POST - Reject complaint
  reject: ({
    complaintId,
    rejectionReason,
    jwt,
    Authorization,
  } = {}) => {
    const request = {
      rejectionReason,
    };

    return Utils.controller(
      `api/admin/complaints/v1/${complaintId}/reject`,
      request,
      "POST",
      "",
      true,
      jwt || Authorization,
      true,
    );
  },

};

export default AdminComplaintController;